var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentContent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }